import { render, staticRenderFns } from "./BehaviorRecord.vue?vue&type=template&id=ddc9b4be"
import script from "./BehaviorRecord.vue?vue&type=script&lang=js"
export * from "./BehaviorRecord.vue?vue&type=script&lang=js"
import style0 from "./BehaviorRecord.vue?vue&type=style&index=0&id=ddc9b4be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports